import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
import { createBrowserRouter, RouterProvider, Navigate, useLocation } from "react-router-dom";
import MainGraduadoLayout from "./Layouts/MainGraduadoLayout";
import StatisticsPage from "./Pages/Graduado/StatisticsPage";
import FormBuilderListPage from "./Pages/Graduado/FormBuilderListPage";
import FormBuilderEditPage from "./Pages/Graduado/FormBuilderEditPage";
import HomeGraduadoPage from "./Pages/Graduado/HomeGraduadoPage";
import ProfilePage from "./Pages/Graduado/ProfilePage";
import LoginPage from "./Pages/LoginPage";
import { isAuthenticated } from "./auth";

function Protected({ children }) {
  const location = useLocation();
  const bypass = sessionStorage.getItem('auth_bypass') || localStorage.getItem('auth_bypass');
  if (!isAuthenticated() && !bypass) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}


const queryClient = new QueryClient();

const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: <MainGraduadoLayout />,
    children: [
      {
        path: "/",
        element: (
          <Protected>
            <HomeGraduadoPage />
          </Protected>
        ),
      },
      {
        path: "/estatisticas",
        element: (
          <Protected>
            <StatisticsPage />
          </Protected>
        ),
      },
      {
        path: "/formularios",
        element: (
          <Protected>
            <FormBuilderListPage />
          </Protected>
        ),
      },
      {
        path: "/formularios/:formId/edit",
        element: (
          <Protected>
            <FormBuilderEditPage />
          </Protected>
        ),
      },
      {
        path: "/meu-perfil",
        element: (
          <Protected>
            <ProfilePage />
          </Protected>
        ),
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
